import React from 'react';
import {useAuth} from "@/provider/AuthProvider";
import {myAcademy} from "@/lib/services/academyService";
import {CalendarOutlined, ClockCircleOutlined} from "@ant-design/icons";

function WelcomeDashboardBox({mode}) {

    const {user} = useAuth()

    const currentDate = new Date();
    const persianDate = new Date().toLocaleDateString('fa-IR');

    const dayName = new Date().toLocaleDateString("fa-IR", {weekday: 'long'});

    let sectionTitle = mode === 'student' ? 'دانش آموزان' : (mode === 'teacher' ?  'اساتید' : (mode === 'admin' ? 'مدیریت' : '-'))
    const hours = currentDate.getHours();
    let greeting = 'سلام';

    if (hours < 12) {
        greeting = 'صبح بخیر';
    } else if (hours < 18) {
        greeting = 'عصر بخیر';
    } else {
        greeting = 'شب بخیر';
    }
    const svg = ( <svg
        viewBox="0 0 240 240"
        fill="none"
        className="h-full w-full text-[#8ee3cf]"
        aria-hidden="true"
    >
        <defs>
            <linearGradient id="gold" x1="35" y1="35" x2="205" y2="205">
                <stop offset="0%" stopColor="#F4DFA2" />
                <stop offset="50%" stopColor="#C8A65C" />
                <stop offset="100%" stopColor="#F4DFA2" />
            </linearGradient>
            <linearGradient id="teal" x1="55" y1="45" x2="185" y2="195">
                <stop offset="0%" stopColor="#8EE3CF" />
                <stop offset="100%" stopColor="#2B9F99" />
            </linearGradient>
        </defs>

        <circle
            cx="120"
            cy="120"
            r="100"
            stroke="url(#gold)"
            strokeWidth="1"
            strokeOpacity=".6"
        />

        {Array.from({ length: 8 }, (_, i) => (
            <g key={i} transform={`rotate(${i * 45} 120 120)`}>
                <path
                    d="M120 20 C105 40 90 55 100 75 C108 90 115 95 120 100 C125 95 132 90 140 75 C150 55 135 40 120 20Z"
                    stroke="url(#gold)"
                    strokeWidth="1.5"
                />
                <path
                    d="M120 35 C110 50 108 65 120 82 C132 65 130 50 120 35Z"
                    stroke="url(#teal)"
                    strokeWidth="1.2"
                />
                <path
                    d="M120 48 Q102 42 106 30 Q120 36 120 48 Q138 42 134 30"
                    stroke="url(#teal)"
                    strokeWidth="1.2"
                />
                <path
                    d="M120 45 Q108 52 120 65 Q132 52 120 45Z"
                    fill="#2B9F99"
                    fillOpacity=".25"
                    stroke="url(#gold)"
                    strokeWidth="1"
                />
            </g>
        ))}

        <circle cx="120" cy="120" r="25" stroke="url(#gold)" strokeWidth="1.5" />
        <circle cx="120" cy="120" r="17" stroke="url(#teal)" strokeWidth="1.2" />

        {Array.from({ length: 8 }, (_, i) => (
            <path
                key={`flower-${i}`}
                d="M120 101 Q128 112 120 120 Q112 112 120 101Z"
                fill="url(#gold)"
                transform={`rotate(${i * 45} 120 120)`}
            />
        ))}

        <circle cx="120" cy="120" r="4" fill="#F4DFA2" />
    </svg>)

    return (
        <div className="relative isolate mb-6 rounded-2xl bg-gradient-to-l from-[#102d3b] via-[#174653] to-[#153448] p-5 text-white shadow-xl sm:p-7">

            <div className="pointer-events-none absolute right-0 -top-16 -z-10 h-64 w-64  opacity-[0.13]">
                {svg}
            </div>

            <div className="pointer-events-none absolute -bottom-20 left-0 -z-10 h-60 w-60  opacity-[0.10]">
                {svg}
            </div>

            <div className="absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-[#cbb47b]/80 to-transparent" />

            <div className="relative flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">

                <div className="min-w-0 text-right">


                    <h1 className="text-2xl font-bold leading-relaxed tracking-tight sm:text-3xl">
                        {greeting}، {user?.useracademy?.firstname}{" "}
                        {user?.useracademy?.lastname}
                    </h1>

                    <div className="mt-3 flex flex-wrap items-center gap-2 text-sm leading-7 text-slate-200">
                        <span>به بخش
                            {' '}
                            {sectionTitle}
                        </span>
                        <span className="rounded-lg   px-1 py-0.5 font-semibold text-[#aee8d8]">
                    {myAcademy("name")}
                </span>
                        <span>خوش آمدید</span>
                    </div>
                </div>

                <div className="flex shrink-0 items-center gap-4 self-start rounded-xl border border-white/15 bg-white/[0.07] p-4 backdrop-blur-sm sm:self-auto sm:px-5">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-[#d6c18b]/30 bg-[#d6c18b]/10 text-[#e6d29d]">
                        <CalendarOutlined className="text-2xl" />
                    </div>

                    <div className="text-right">
                        <p className="mb-1 flex items-center gap-2 text-sm text-slate-300">
                            <ClockCircleOutlined />
                            امروز {dayName}
                        </p>
                        <p className="text-lg font-bold tracking-wide text-white">
                            {persianDate}
                        </p>
                    </div>
                </div>
            </div>

            <div className="mt-6 flex items-center justify-center gap-3">
                <div className="h-px flex-1 bg-gradient-to-l from-[#cbb47b]/50 to-transparent" />
                <svg viewBox="0 0 36 18" className="h-4 w-9 text-[#d6c18b]" fill="none">
                    <path d="M18 1 L23 6 L18 9 L13 6 Z M18 9 L23 12 L18 17 L13 12 Z M1 9 H12 M24 9 H35" stroke="currentColor" strokeWidth="1.2" />
                </svg>
                <div className="h-px flex-1 bg-gradient-to-r from-[#cbb47b]/50 to-transparent" />
            </div>
        </div>
    );
}

export default WelcomeDashboardBox;